/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type time_tracking_CreateBreakEntryRequest = {
    /**
     * Break end time in RFC3339 format
     */
    break_end: string;
    /**
     * Break start time in RFC3339 format
     */
    break_start: string;
    /**
     * Break type: SCHEDULED, MANUAL, AUTO_DEDUCTED (defaults to MANUAL if omitted)
     */
    break_type?: time_tracking_CreateBreakEntryRequest.break_type;
    /**
     * Optional notes for the break
     */
    notes?: string;
};
export namespace time_tracking_CreateBreakEntryRequest {
    /**
     * Break type: SCHEDULED, MANUAL, AUTO_DEDUCTED (defaults to MANUAL if omitted)
     */
    export enum break_type {
        SCHEDULED = 'SCHEDULED',
        MANUAL = 'MANUAL',
        AUTO_DEDUCTED = 'AUTO_DEDUCTED',
    }
}

